import { render, staticRenderFns } from "./Abbreviation.vue?vue&type=template&id=0bb5eb47"
import script from "./Abbreviation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Abbreviation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports